import { RouteConfig } from '../types/route'

/**
 * 判断是否存在有效的页面路由
 *
 * @param children 子路由
 * @returns boolean
 */
const existValidPageRoute = (children?: RouteConfig[]): boolean => {
  if (!children?.length) {
    return false
  }
  return children.some(item => {
    return item.isPage || existValidPageRoute(item.children)
  })
}

/**
 * 过滤有权访问的路由
 *
 * @param configs 路由配置
 * @param hasPermission 权限判断函数
 * @returns 授权的路由
 */
export const filterAuthorizedConfigs = (
  configs: RouteConfig[],
  hasPermission: (permission: string) => boolean
): RouteConfig[] => {
  const newRoutes = configs.map(({ children, ...item }) => {
    // 使用展开运算符复制一份副本，不要直接修改原对象
    const route: RouteConfig = item

    const newChildren = children
      ? filterAuthorizedConfigs(children, hasPermission)
      : undefined

    // 处理子路由
    if (newChildren && newChildren.length > 0) {
      route.children = newChildren
    }

    // 优先校验自身的权限
    if (route.uuid) {
      return hasPermission(route.uuid) ? route : undefined
    }

    // 没有权限限制的路由，或者有子路由的路由
    if (route.path || existValidPageRoute(newChildren)) {
      return route
    }

    // 空白的目录节点
    return undefined
  })

  return newRoutes.filter((menu): menu is RouteConfig => {
    return !!menu
  })
}
